import { registerLocaleData } from '@angular/common';
import {
  HTTP_INTERCEPTORS,
  withInterceptorsFromDi,
  provideHttpClient,
} from '@angular/common/http';
import LocaleNl from '@angular/common/locales/nl';
import {
  enableProdMode,
  LOCALE_ID,
  importProvidersFrom,
  provideAppInitializer,
  inject,
  provideZonelessChangeDetection,
  ErrorHandler,
} from '@angular/core';
import { BrowserModule, bootstrapApplication } from '@angular/platform-browser';
import {
  RouteReuseStrategy,
  provideRouter,
  withComponentInputBinding,
} from '@angular/router';
import { environment } from '@environments/environment';
import { Ad6ErrorHandler } from '@error/ad6-error-handler';
import { AppInitService } from '@init/app-init.service';
import { provideIonicAngular } from '@ionic/angular/standalone';
import { IonicRouteStrategy } from '@ionic/angular/standalone';
import { provideTranslateService } from '@ngx-translate/core';
import { provideTranslateHttpLoader } from '@ngx-translate/http-loader';
import { AppIdentifierInterceptor } from '@shared/interceptor/app-identifier.interceptor';
import { EventInterceptor } from '@shared/interceptor/event.interceptor';
import { Observable } from 'rxjs';
import { register as registerSwiperElements } from 'swiper/element/bundle';

import { AppComponent } from './app/app.component';
import { routes } from './app/app.routes';

registerLocaleData(LocaleNl);

if (environment.production) {
  enableProdMode();
}

registerSwiperElements();

const appInit = (appInitService: AppInitService) => (): Observable<boolean> =>
  appInitService.initialize();

bootstrapApplication(AppComponent, {
  providers: [
    importProvidersFrom(BrowserModule),
    {
      provide: RouteReuseStrategy,
      useClass: IonicRouteStrategy,
    },
    provideAppInitializer(() => {
      const initializerFn = appInit(inject(AppInitService));

      return initializerFn();
    }),
    {
      provide: LOCALE_ID,
      useValue: 'nl-NL',
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: EventInterceptor,
      multi: true,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AppIdentifierInterceptor,
      multi: true,
    },
    {
      provide: ErrorHandler,
      useClass: Ad6ErrorHandler,
    },
    provideHttpClient(withInterceptorsFromDi()),
    provideRouter(routes, withComponentInputBinding()),
    provideZonelessChangeDetection(),
    provideIonicAngular({
      // eslint-disable-next-line @typescript-eslint/naming-convention
      innerHTMLTemplatesEnabled: true,
      // eslint-disable-next-line @typescript-eslint/naming-convention
      useSetInputAPI: true, // Support @Input signals for modals
    }),
    provideTranslateService({
      fallbackLang: 'nl',
      loader: provideTranslateHttpLoader({
        prefix: './assets/i18n/',
        suffix: '.json',
      }),
    }),
  ],
}).catch(err => console.log(err));
